export default __webpack_public_path__ + "static/media/lucky-spin-banner-ms.fb221c0c.webp";